import { REACT_APP_API_ENDPOINT } from "../helpers/data";
import { handleResponse, sendPostRequest } from "./apiUtilis";

export const loginClient = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/login", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};

export const logoutClient = async () => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/logout");
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};

export const confirmVerifyCode = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/verify-code", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};

export const requestVerifyCode = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/request-code", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};

export const requestPassResetCode = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/request-reset", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};

export const requestSetNewPassword = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/set-password", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
}

export const refreshTokens = async () => {
    try {
      await sendPostRequest(REACT_APP_API_ENDPOINT + "auth/refresh-token")
      console.log("Tokens refreshed successfully.");
    } catch (error) {
      console.error("Error refreshing tokens:", error);
      // Handle re-authentication if refresh token fails
    }
  };
  